import { render } from "./TeamPoints.vue?vue&type=template&id=2993290e&scoped=true"
import script from "./TeamPoints.vue?vue&type=script&lang=js"
export * from "./TeamPoints.vue?vue&type=script&lang=js"

import "./TeamPoints.vue?vue&type=style&index=0&id=2993290e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2993290e"]])

export default __exports__